import React, { useEffect, useState } from "react";
import {
  FButton,
  FCard,
  FContainer,
  FGrid,
  FGridItem,
  FItem,
  // FResponseBar,
  FTypo,
} from "ferrum-design-system";
import IconActiveRight from "../../../../../assets/img/right-icon-light-grey.svg";
import IconActiveLeft from "../../../../../assets/img/left-icon-light-grey.svg";
import { CrucibleManage } from "../common/CardManage";
import { CrucibleMyBalance } from "../../../common/CardMyBalance";
import { PATH_DASHBOARD } from "../../../../../routes/paths";
import { useHistory, useLocation, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { BigUtils } from "./../../../../../container-components/web3Client/types";
import { RootState } from "../../../../../redux/rootReducer";
import ClipLoader from "react-spinners/ClipLoader";
import { STEP_FLOW_IDS } from "../../../common/utils";
import {
  getAPRValueAgainstFarm,
  getHumanReadableFarmName,
  getLatestStepToRender,
  getObjectReadableFarmName,
} from "../../../common/Helper";
import * as SFSH_API from "../../../../../_apis/StepFlowStepHistory";
import * as CrucibleActions from "../../../redux/CrucibleActions";
import {
  getErrorMessage,
  TruncateWithoutRounding,
} from "../../../../../utils/global.utils";
import IconNetworkCFrmStr from "../../../../../assets/img/icon-network-cfrm.svg";
import IconNetworkCFrmxStr from "../../../../../assets/img/icon-network-cfrmx.svg";
import { ReactComponent as IconNetworkBnb } from "../../../../../assets/img/icon-network-bnb.svg";
import { useWalletConnector } from "foundry";
import { createGlobalStyle, ThemeProvider } from "styled-components";
import { getCrucibleFees } from "../../../../../_apis/CABNCrud";
import { TOKEN_TAG } from "../../../../../utils/const.utils";

export const Manage = () => {
  const history = useHistory();
  let { farm } = useParams<{ farm?: string }>();
  farm = farm === "cFRM-ARBITRUM" ? "cTestFrm" : farm;
  const location: any = useLocation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dashboardAction, setDashboardAction] = useState(false);
  const [fees, setFees] = useState<{
    transferFee: number;
    buyFee: number;
    sellFee: number;
    stakeFee: number;
    unwrapFee: number;
    unstakeFee: number;
  }>({
    transferFee: 0,
    buyFee: 0,
    sellFee: 0,
    stakeFee: 0,
    unwrapFee: 0,
    unstakeFee: 0,
  });

  const { web3Sdk } = useWalletConnector();
  const { stepFlowStepHistory, currentStep, currentStepIndex, aprInformation } =
    useSelector((state: RootState) => state.crucible);
  const { tokenV2 } = useSelector(
    (state: RootState) => state.walletAuthenticator
  );
  const { theme, content } = useSelector((state: RootState) => state.config);
  const LPStakingDetails = useSelector(
    (state: RootState) => state.crucible.userLpStakingDetails
  );
  const crucible = useSelector(
    (state: RootState) => state.crucible.selectedCrucible
  );
  const userCrucibleData = useSelector(
    (state: RootState) => state.crucible.userCrucibleDetails
  );
  let userStake =
    userCrucibleData[farm!] &&
    (userCrucibleData[farm!].stakes || []).find(
      (e: any) =>
        e.address.toLowerCase() ===
        location.state.LPstakingAddress.toLowerCase()
    );
  const { activeTranslation } = useSelector((state: RootState) => state.phrase);
  const [activeAPRIndex, setActiveAPRIndex] = useState(0);
  const aprData =
    Object.keys(aprInformation).length &&
    getAPRValueAgainstFarm(aprInformation, farm);

  useEffect(() => {
    if (currentStep && currentStep._id && currentStep.status === "pending") {
      getStepCompletedAndRunCompletionFlow(false);
    }
  }, []);

  useEffect(() => {
    if (location.state === undefined) {
      history.push(PATH_DASHBOARD.crucible.index);
    }
  }, [location]);

  const getStepCompletedAndRunCompletionFlow = async (renderNeeded: any) => {
    // setIsLoading(true);
    try {
      let updatedCurrentStep = { ...currentStep, status: "completed" };
      let updHistory = stepFlowStepHistory.map((obj, index) =>
        index === currentStepIndex ? { ...obj, status: "completed" } : obj
      );
      let data = { status: "completed" };

      dispatch(
        CrucibleActions.updateCurrentStep({
          currentStep: updatedCurrentStep,
          currentStepIndex: currentStepIndex,
        })
      );
      dispatch(
        CrucibleActions.updateStepFlowStepHistory({
          stepFlowStepHistory: updHistory,
        })
      );

      // let updateResponse: any =
      await SFSH_API.updateStepsFlowStepsHistoryStatusByAssociatedUserIdByStepsFlowStepsHistoryId(
        currentStep._id,
        data,
        tokenV2
      );
      // console.log('updateStepsFlowStepsHistoryStatusByAssociatedUserIdByStepsFlowStepsHistoryId', 'dashboard.tsx 75')
      // updateResponse = updateResponse?.data?.body?.stepsFlowStepHistory;
      runCompletionFlow(stepFlowStepHistory);
      getLatestStepToRender(
        location.state,
        tokenV2,
        currentStep,
        currentStepIndex,
        stepFlowStepHistory,
        dispatch,
        history,
        farm,
        setIsLoading,
        renderNeeded,
        true
      );
    } catch (e: any) {
      setIsLoading(false);
      getErrorMessage(e, activeTranslation);
    }
  };

  const runCompletionFlow = async (stepFlowStepHistory: any) => {
    for (let i = 0; i < stepFlowStepHistory.length; i++) {
      if (stepFlowStepHistory[i].status === "started") {
        // console.log('updateStepsFlowStepsHistoryStatusByAssociatedUserIdByStepsFlowStepsHistoryId', 'dashboard 88')
        await SFSH_API.updateStepsFlowStepsHistoryStatusByAssociatedUserIdByStepsFlowStepsHistoryId(
          stepFlowStepHistory[i]._id,
          { status: "completed" },
          tokenV2
        );
      }
    }
  };

  const getCrucibleFee = async () => {
    const farmCabn = {
      cFRM: "626c591625c981612853f3a5",
      cTestFrm: "6519d1a2076c99556a61ef8f",
    };

    const res = await getCrucibleFees(
      farmCabn[farm as keyof typeof farmCabn],
      TOKEN_TAG
    );
    if (res.data?.body?.data?.length) {
      setFees(res.data?.body?.data[0]);
    }
  };

  useEffect(() => {
    getCrucibleFee();
  }, []);

  const onUnStakeClick = () => {
    setIsLoading(true);
    let nextStepInfo: any =
      STEP_FLOW_IDS[`${getObjectReadableFarmName(farm)}`].unstake;
    location.state.id = nextStepInfo.id;
    location.state.stepFlowName = nextStepInfo.name;
    getLatestStepToRender(
      location.state,
      tokenV2,
      currentStep,
      currentStepIndex,
      stepFlowStepHistory,
      dispatch,
      history,
      farm,
      setIsLoading
    );
    setIsLoading(false);
  };

  const onStakeClick = async () => {
    setIsLoading(true);
    let nextStepInfo: any =
      STEP_FLOW_IDS[`${getObjectReadableFarmName(farm)}`].stake;
    location.state.id = nextStepInfo.id;
    location.state.stepFlowName = nextStepInfo.name;
    getLatestStepToRender(
      location.state,
      tokenV2,
      currentStep,
      currentStepIndex,
      stepFlowStepHistory,
      dispatch,
      history,
      farm,
      setIsLoading
    );
    setIsLoading(false);
  };

  const onClaimRewardsClick = () => {
    setIsLoading(true);
    let nextStepInfo: any =
      STEP_FLOW_IDS[`${getObjectReadableFarmName(farm)}`].withdraw;
    location.state.id = nextStepInfo.id;
    location.state.stepFlowName = nextStepInfo.name;
    getLatestStepToRender(
      location.state,
      tokenV2,
      currentStep,
      currentStepIndex,
      stepFlowStepHistory,
      dispatch,
      history,
      farm,
      setIsLoading
    );
    setIsLoading(false);
  };

  const onAddLiquidityClick = () => {
    setIsLoading(true);
    let nextStepInfo: any =
      STEP_FLOW_IDS[`${getObjectReadableFarmName(farm)}`].generalAddLiquidity;
    location.state.id = nextStepInfo.id;
    location.state.stepFlowName = nextStepInfo.name; // getting no history againts this id
    getLatestStepToRender(
      location.state,
      tokenV2,
      currentStep,
      currentStepIndex,
      stepFlowStepHistory,
      dispatch,
      history,
      farm,
      setIsLoading
    );
    setIsLoading(false);
  };

  const onWrapClick = () => {
    setIsLoading(true);
    let nextStepInfo: any =
      STEP_FLOW_IDS[`${getObjectReadableFarmName(farm)}`].unwrap;
    // console.log(nextStepInfo, location.state);
    location.state.id = nextStepInfo.id;
    location.state.stepFlowName = nextStepInfo.name;
    getLatestStepToRender(
      location.state,
      tokenV2,
      currentStep,
      currentStepIndex,
      stepFlowStepHistory,
      dispatch,
      history,
      farm,
      setIsLoading
    );
  };

  const getRewardAmount = () => {
    if (farm?.includes("BNB")) {
      return TruncateWithoutRounding(
        web3Sdk?.utils.fromWei(
          String(LPStakingDetails[farm!]?.rewards[0]?.rewardAmount || 0),
          "ether"
        ),
        3
      );
    } else {
      let userStake = (
        (userCrucibleData[farm!] && userCrucibleData[farm!].stakes) ||
        []
      ).find(
        (e: any) =>
          e.address.toLowerCase() ===
          location.state.LPstakingAddress.toLowerCase()
      );
      return TruncateWithoutRounding(userStake?.rewardOf || 0, 3);
    }
  };

  const getRewardSymbol = () => {
    return crucible[farm!]?.symbol;
  };

  const GlobalStyles = createGlobalStyle`
  .crucible-card {
    .crucible-farm-dashboard-card-2 {
      background-image: url(${theme?.cards?.crucibleTokenCard}) !important;
    }
    .clr_black_light {
      color:${theme?.colors?.backgroundLight}!important;
      }
      .clr_white{
        color:${theme?.colors?.primaryLight}!important;
      }
      .unlcaimed-text {
        color:${theme?.colors?.primary}!important;
      }
      .claim-token-btn {
        outline:1px solid${theme?.colors?.primary}!important;
        background:${theme?.colors?.primary}!important;
        border:1px solid ${theme?.colors?.primary}!important;
        color: ${theme?.colors?.backgroundDark}!important;
      }
      .unstake-btn {
        background:${theme?.colors?.backgroundDark}!important;
        color:${theme?.colors?.primary}!important;
        border:1px solid ${theme?.colors?.primary}!important;
      }
      .unwrap-btn {
        background:${theme?.colors?.backgroundDark}!important;
        color:${theme?.colors?.primaryLight}!important;
        border:1px solid ${theme?.colors?.primaryLight}!important;
      }
      .stake-btn {
        outline:1px solid${theme?.colors?.primary}!important;
        background:${theme?.colors?.primary}!important;
        border:1px solid ${theme?.colors?.primary}!important;
        color:${theme?.colors?.backgroundDark}!important;
      }
      .unwrap-farm-card {
        background: ${theme?.colors?.background} !important;
        border: 1px solid ${theme?.colors?.neutralLight}!important;
      }
    }
  `;
  const crucibleWlConfig = theme?.crucibleConfig;
  const customClaimLink = crucibleWlConfig?.customClaimLink.match(/^https?:/)
    ? crucibleWlConfig?.customClaimLink
    : "//" + crucibleWlConfig?.customClaimLink;

  return (
    <ThemeProvider theme={theme}>
      <FContainer className="card-manage min-100vw new-design-container-paddings-lr crucible-card ">
        {isLoading ? (
          // <FCard>
          <FItem align={"center"}>
            <ClipLoader
              color={theme?.colors?.primary}
              loading={true}
              size={150}
            />
          </FItem>
        ) : (
          // </FCard>
          <>
            <div className="justify_start align_start d-flex w-100">
              <div className={"custom-mr-50"}>
                <CrucibleManage
                  dashboardAction={dashboardAction}
                  setDashboardAction={setDashboardAction}
                />
                {!crucibleWlConfig?.isCustomClaimEnabled && (
                  <FContainer>
                    <div className="crucible-farm-dashboard-card-2">
                      <div className={"f-mt-1 f-mb-1"}>
                        <div className="flex-center-aligned-center">
                          {/* <span
                            className="icon-wrap custom-mr-12 "
                            style={{ marginLeft: 24 }}
                          >
                            <img
                              src={
                                farm?.includes("cFRMx")
                                  ? IconNetworkCFrmxStr
                                  : IconNetworkCFrmStr
                              }
                              alt="network-cfrm"
                            />
                            {farm?.includes("BNB") && <IconNetworkBnb />}
                          </span> */}
                          {/* <p className="custom-font-size-20 font-700 custom-mr-24 clr_white ">
                            {crucibleWlConfig?.crucibleFarms[0]
                              ?.sustainableCrucibleFarms ||
                              getHumanReadableFarmName(farm)}
                          </p> */}
                          <FTypo
                            size={16}
                            weight={700}
                            color={theme?.colors?.primaryLight}
                          >
                            Crucible Token
                          </FTypo>
                        </div>
                        <FGrid
                          alignX={"center"}
                          className={"f-mt-1 unwrap-farm-card"}
                        >
                          <FGridItem
                            alignX={"center"}
                            alignY={"center"}
                            dir={"column"}
                            size={[2, 2, 2]}
                          >
                            <p
                              className={
                                "custom-font-size-18 font-600 clr_white "
                              }
                            >
                              {fees.buyFee || 0}%
                            </p>
                            <p
                              className={"custom-font-size-10 clr_black_light"}
                            >
                              Buy Fee
                            </p>
                          </FGridItem>
                          <FGridItem
                            alignX={"center"}
                            alignY={"center"}
                            dir={"column"}
                            size={[2, 2, 2]}
                          >
                            <p
                              className={
                                "custom-font-size-18 font-600 clr_white "
                              }
                            >
                              {fees.sellFee || 0}%
                            </p>
                            <p
                              className={"custom-font-size-10 clr_black_light"}
                            >
                              Sell Fee
                            </p>
                          </FGridItem>
                          <FGridItem
                            alignX={"center"}
                            alignY={"center"}
                            dir={"column"}
                            size={[2, 2, 2]}
                          >
                            <p
                              className={
                                "custom-font-size-18 font-600 clr_white"
                              }
                            >
                              {`${fees.unwrapFee}%` ||
                                `${BigUtils.safeParse(
                                  crucible[farm!]?.feeOnWithdrawRate || "0"
                                )
                                  .times(100)
                                  .toString()}%`}
                            </p>
                            <p
                              className={"custom-font-size-10 clr_black_light"}
                            >
                              Unwrap Fee
                            </p>
                          </FGridItem>
                          <FGridItem
                            alignX={"center"}
                            alignY={"center"}
                            dir={"column"}
                            size={[2, 2, 2]}
                          >
                            <p
                              className={
                                "custom-font-size-18 font-600 clr_white "
                              }
                            >
                              {`${fees.stakeFee}%` ||
                                `${BigUtils.safeParse(
                                  crucible[farm!]?.feeOnTransferRate || "0"
                                )
                                  .times(100)
                                  .toString()}%`}
                            </p>
                            <p
                              className={"custom-font-size-10 clr_black_light"}
                            >
                              Stake Fee
                            </p>
                          </FGridItem>
                          <FGridItem
                            alignX={"center"}
                            alignY={"center"}
                            dir={"column"}
                            size={[2, 2, 2]}
                          >
                            <p
                              className={
                                "custom-font-size-18 font-600 clr_white "
                              }
                            >
                              {`${fees.unstakeFee}%` ||
                                `${BigUtils.safeParse(
                                  crucible[farm!]?.feeOnWithdrawRate || "0"
                                )
                                  .times(100)
                                  .toString()}%`}
                            </p>
                            <p
                              className={"custom-font-size-10 clr_black_light"}
                            >
                              Unstake Fee
                            </p>
                          </FGridItem>
                          <FGridItem
                            alignX={"center"}
                            alignY={"center"}
                            dir={"column"}
                            size={[2, 2, 2]}
                          >
                            <p
                              className={
                                "custom-font-size-18 font-600 clr_white "
                              }
                            >
                              {`${fees.transferFee}%` ||
                                `${BigUtils.safeParse(
                                  crucible[farm!]?.feeOnTransferRate || "0"
                                )
                                  .times(100)
                                  .toString()}%`}
                            </p>
                            <p
                              className={"custom-font-size-10 clr_black_light"}
                            >
                              Transfer Fee
                            </p>
                          </FGridItem>
                        </FGrid>
                      </div>
                    </div>
                  </FContainer>
                )}
                <FContainer>
                  <div className="btn-wrap f-mt-2 f-mb-2 justify-content-end align_center">
                    <>
                      <FButton
                        title={"CLAIM"}
                        variant={"secondary"}
                        className={
                          "custom-mr-16 custom-font-size-16 font-700 unstake-btn "
                        }
                        style={{
                          width: 124,
                          borderColor: "#D9B373",
                          borderRadius: 8,
                        }}
                        onClick={() => onClaimRewardsClick()}
                      ></FButton>
                    </>
                    <FButton
                      variant={"secondary"}
                      title={"UNSTAKE"}
                      outlined
                      className={
                        "custom-mr-16 custom-font-size-16 font-700 unstake-btn "
                      }
                      style={{
                        width: 124,
                        borderColor: "#D9B373",
                        borderRadius: 8,
                      }}
                      onClick={() => onUnStakeClick()}
                    ></FButton>
                    <FButton
                      title={"STAKE"}
                      className={
                        "clr_new_black custom-font-size-16 font-700 stake-btn "
                      }
                      style={{ width: 266 }}
                      onClick={() => onStakeClick()}
                    ></FButton>

                    {(farm === "cFRM-BNB" || farm === "cFRMx-BNB") && (
                      <FButton
                        variant={"secondary"}
                        title={"ADD LIQUIDITY"}
                        outlined
                        style={{ width: 266 }}
                        onClick={() => onAddLiquidityClick()}
                      ></FButton>
                    )}
                  </div>
                </FContainer>
              </div>
              <div>
                <CrucibleMyBalance />
              </div>
            </div>

            {/* <FResponseBar variant="success" title={"Withdraw Transaction Successful. [ 0x06167934...5bvf645949c ]"} /> */}
          </>
        )}
      </FContainer>
      <GlobalStyles />
    </ThemeProvider>
  );
};
